import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {ToastService} from "../../../main/services";
import {TenderRevisionService} from "../../services";

@Component({
    selector: 'jft-revision-tab-models',
    templateUrl: './revision-tab-models.component.html',
    styleUrls: ['./revision-tab-models.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RevisionTabModelsComponent implements OnInit {
    @Input() public tenderId;

    @Input() public baseCurrencyCode;
    @Input() public baseUnitCode;
    @Input() public finalBaseAmount;
    @Input() public finalGap;
    @Input() public finalGapTotal;
    @Input() public currentContractsTotal;
    @Input() public totalVolume;
    @Input() public selectedContractsTotal;
    @Input() public selectedTotalVolume;
    @Input() public hasSelectedBids;
    @Input() public canManage: boolean = true;

    @Output() onChanged = new EventEmitter();
    @Output() onSelectedTab = new EventEmitter();
    @Output() onChanged2 = new EventEmitter();

    public selectedModelTab;
    public modelTabs = [];

    constructor(
        private route: ActivatedRoute,
        protected toast: ToastService,
        private router: Router,
        private service: TenderRevisionService,
    ) {
    }

    ngOnInit(): void {
        this.fetchModelTabs();

        this.service.onRemoveOfferTabModels.subscribe(offerId => {
            this.modelTabDeleteOffer(offerId);
            this.saveModelTabs();
        })

        this.service.onUpdateOfferTabModels.subscribe(data => {
            this.modelTabUpdateOffers(data['offerId'], data['value']);
            this.saveModelTabs();
        })

        this.service.onSaveModelSettings.subscribe(data => {
            this.saveModelTabs();
        })

        this.service.onDeleteModelSettings.subscribe(model => {
            this.modelTabs.forEach((item, index, object) => {
                if (item.id == model.id) {
                    object.splice(index, 1);
                }
            })
            this.modelTabs.forEach((item, index, object) => {
                item.id = index + 1;
            })
            this.saveModelTabs();
        })
    }

    private fetchModelTabs() {
        /**
         * Example json:
         * this.modelTabs = [
         *             {
         *                 id: 1,
         *                 active: false,
         *                 name: 'Model 1',
         *                 text: 'Fuel purchased from Shell, WSF 1',
         *                 descr: 'Description',
         *                 offers_awarded: [
         *                     {
         *                         id: 86267,
         *                         percent: 100
         *                     }, {
         *                         id: 86272,
         *                         percent: 100
         *                     }
         *                 ]
         *             },
         *             {
         *                 id: 2,
         *                 active: true,
         *                 name: 'Model 2',
         *                 text: 'Fuel purchased from Shell, WSF 2',
         *                 descr: 'Description',
         *                 offers_awarded: [
         *                     {
         *                         id: 86267,
         *                         percent: 40
         *                     },
         *                     {
         *                         id: 86272,
         *                         percent: 29
         *                     }
         *                 ]
         *             },
         *         ];
         */
        this.service.fetchModels(this.tenderId)
            .subscribe((items: any) => {
                if (items && items.length){
                    this.modelTabs = items;
                    this.selectedModelTab = this.modelTabs.filter(item => item.active)[0];
                    this.onSelectedTab.emit(this.selectedModelTab);
                }
            });
    }

    public modelTabChange(id) {
        this.modelTabs.forEach(item => {
            item.active = item.id == id;
        })
        this.selectedModelTab = this.modelTabs.filter(item => item.active)[0];
        this.onSelectedTab.emit(this.selectedModelTab);

        this.service.updateModels(this.tenderId, this.modelTabs)
            .subscribe((items: any) => {

            });
    }

    public createNewModelTab(event){
        let id = this.modelTabs.length + 1;

        this.modelTabs.push({
                id: id,
                active: false,
                name: 'Model '+id,
                text: '',
                offers_awarded: []
            })
        this.modelTabChange(id);
    }

    private setActiveModelTab(id) {
        this.selectedModelTab = this.modelTabs.find(item => item.id == id);
    }

    public modelTabTextChange(event){
        this.saveModelTabs();
    }

    public saveModelTabs(){
        this.onChanged.emit(this.modelTabs);
        this.service.updateModels(this.tenderId, this.modelTabs)
            .subscribe((items: any) => {
                //this.onChanged.emit(items);
            });
    }

    private modelTabDeleteOffer(offerId) {
        let activeModelTab = this.selectedModelTab;
        if (!activeModelTab){
            return
        }

        activeModelTab.offers_awarded.forEach((item, index, object) => {
            if (item.id == offerId) {
                object.splice(index, 1);
            }
        })
    }

    private modelTabUpdateOffers(offerId, value) {
        let activeModelTab = this.selectedModelTab;
        if (!activeModelTab){
            return
        }
        let isExist = false;
        activeModelTab.offers_awarded.forEach(item => {
            if (item.id == offerId) {
                isExist = true
                item.percent = value;
            }
        })
        if (isExist === false) {// new element
            activeModelTab.offers_awarded.push({id: offerId, percent: value})
        }
    }

}
